import { Avatar } from '../../Atomics/Avatar';
import Box from '../../Atomics/Box';
import { Heading } from '../../Atomics/Heading';
import { Paragraph } from '../../Atomics/Paragraph';
import CustomIcon from '../../Icons/CustomIcon';

type TProps = {
    title: string;
    description: string;
};

const SuccessFeedback = ({ title, description }: TProps) => {
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box mb="md">
                <Avatar border="none" position="relative" bg="green-nova" size={96}>
                    <CustomIcon icon="SuccessIcon" customColor="white" width={48} height={48} />
                </Avatar>
            </Box>

            <Heading level={2} mt="lg" mb="sm" textAlign="center">{title}</Heading>
            <Paragraph typography="text-s-medium" textAlign="center">{description}</Paragraph>
        </Box>
    );
};

export default SuccessFeedback;
